export function saveToShoppingCart(id, category, variant = null, amount = 1) {
    let shoppingCart = localStorage.getItem("carrito");

    // Si no hay carrito en localStorage, lo inicializamos como un arreglo vacío
    if (!shoppingCart) {
        shoppingCart = [];
    } else {
        shoppingCart = JSON.parse(shoppingCart); // Convertimos a un arreglo si ya existe
    }

    // Verificar si el id con la misma categoría y variante ya existe en el carrito
    const existingItem =
        shoppingCart.find(item => item.id === id && item.category === category && item.variant === variant);

    if (existingItem) {
        alert('Este producto ya está en el carrito.');
    } else {
        // Añadimos la tupla como un objeto con id, category, variant y amount
        shoppingCart.push({ id, category, variant, amount });
        localStorage.setItem("carrito", JSON.stringify(shoppingCart));
        alert('Agregado correctamente al carrito');
    }
}


export function convertShoppingCartStringToArray() {
    var shoppingCart = localStorage.getItem("carrito");
    if (!shoppingCart) return null;
    return JSON.parse(shoppingCart);
}

export function updateAmount(id, category, variant = null, newAmount) {

    if (isNaN(newAmount) || newAmount < 1 || !Number.isInteger(Number(newAmount))) {
        return;
    }

    let shoppingCart = localStorage.getItem("carrito");

    if (!shoppingCart) {
        alert('El carrito está vacío');
        return;
    }
    shoppingCart = JSON.parse(shoppingCart); // Convertimos el carrito a un arreglo

    // Buscar el item con el id, category y variant correspondientes
    const itemIndex = shoppingCart.findIndex(item => item.id === id && item.category === category && item.variant === variant);

    if (itemIndex === -1) {
        alert('Producto no encontrado en el carrito');
    } else {
        // Actualizamos la cantidad del item
        shoppingCart[itemIndex].amount = Number(newAmount);
        localStorage.setItem("carrito", JSON.stringify(shoppingCart));
    }
}

// Función para eliminar un item del carrito
export function deleteItem(id, category, variant = null) {
    let shoppingCart = localStorage.getItem("carrito");

    if (!shoppingCart) {
        alert('El carrito está vacío');
        return;
    }

    shoppingCart = JSON.parse(shoppingCart); // Convertimos el carrito a un arreglo

    // Buscar el item con el id, category y variant correspondientes
    const itemIndex = shoppingCart.findIndex(item => item.id === id && item.category === category && item.variant === variant);

    if (itemIndex === -1) {
        alert('Producto no encontrado en el carrito');
    } else {
        // Eliminamos el item del carrito
        shoppingCart.splice(itemIndex, 1);
        localStorage.setItem("carrito", JSON.stringify(shoppingCart));
        alert('Producto eliminado del carrito');
    }
}
